import Main from 'mmbclient/Main/Main';
import './App.css';
import 'react-datepicker/dist/react-datepicker.css';

function App() {
  return (
    <Main />
  );
}

export default App;
